module.exports = __webpack_public_path__ + "static/hero-talent-mobility-1afa9aa2fa7fcb77ad9224163e014d82.svg";